module.exports = __webpack_public_path__ + "static/img/our-team.1a62ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About-pics/our-team.jpg
// module id = nejm
// module chunks = 0